import { FormSectionTextField } from "./FormSectionTextField";
import { FormSectionToggle } from "./FormSectionToggle";
import * as validate from "../FormElements/validation";

export enum FieldWidth {
  HALF = "half",
  FULL = "full",
}

export type Field = {
  name: string;
  isEditable: boolean;
  width: FieldWidth;
  label: string;
  required?: { value: boolean; message: string };
  validator: (input: validate.Validatable) => validate.ValidationResult;
  defaultValue: string;
};

export type ToggleField = {
  name: string;
  isEditable: boolean;
  width: FieldWidth;
  label: string;
  toggleSize: "small" | "large";
};

export interface FormSectionProps {
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmit: (data: any) => void;
  title: string;
  defaultValues?: object;
}

export interface FormSectionSubComponents {
  TextField: typeof FormSectionTextField;
  Toggle: typeof FormSectionToggle;
}
